var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 11 11","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 5.38974L3.92331 9L10 1","stroke":_vm.fill,"stroke-linecap":"round","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }